import { getScreenName } from '@rhg/libs/analytics/track-page-nav';
import useAuth from '@rhg/libs/auth0/use-auth';
import { Container, ContainerProps } from '@rhg/libs/material';
import { useRouter } from 'next/router';
import { PropsWithChildren, useMemo } from 'react';
import { MAIN_CONTENT_ID } from '../skip-to-main';

interface MainContainerProps extends ContainerProps {
    title?: string;
    testId?: string;
}

const MainContainer = ({
    title,
    sx,
    testId,
    children,
    maxWidth = false,
    ...containerProps
}: PropsWithChildren<MainContainerProps>) => {
    const { pathname, query } = useRouter();
    const { isAuthenticated } = useAuth();

    const trackScreen = useMemo(
        () =>
            getScreenName(
                { pathname, query },
                { IsAuthenticated: isAuthenticated }
            ),
        [pathname, query, isAuthenticated]
    );

    return (
        <Container
            {...containerProps}
            component="main"
            disableGutters={true}
            maxWidth={maxWidth}
            id={MAIN_CONTENT_ID}
            tabIndex={-1}
            title={title}
            data-testid={`VIEW_${testId ?? trackScreen}`}
            sx={sx}
        >
            {children}
        </Container>
    );
};

export default MainContainer;
